/* IndexedDB wrapper for the offline attendance queue. */
import { openDB } from "idb";

const DB_NAME = "presence-pwa";
const DB_VERSION = 1;
const STORE = "attendance_queue";
const META = "meta";

let dbPromise = null;

function getDb() {
  if (!dbPromise) {
    dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(db) {
        if (!db.objectStoreNames.contains(STORE)) {
          const store = db.createObjectStore(STORE, { keyPath: "local_id" });
          store.createIndex("sync_status", "sync_status");
          store.createIndex("captured_at_device", "captured_at_device");
        }
        if (!db.objectStoreNames.contains(META)) {
          db.createObjectStore(META, { keyPath: "key" });
        }
      },
    });
  }
  return dbPromise;
}

export async function enqueueAttendance(record) {
  const db = await getDb();
  await db.put(STORE, record);
  return record.local_id;
}

export async function updateAttendance(local_id, patch) {
  const db = await getDb();
  const existing = await db.get(STORE, local_id);
  if (!existing) return null;
  const updated = { ...existing, ...patch };
  await db.put(STORE, updated);
  return updated;
}

export async function getAttendance(local_id) {
  const db = await getDb();
  return db.get(STORE, local_id);
}

export async function listAttendance() {
  const db = await getDb();
  return db.getAll(STORE);
}

export async function listPending() {
  const db = await getDb();
  const all = await db.getAll(STORE);
  return all.filter((r) => r.sync_status === "PENDING" || r.sync_status === "FAILED");
}

export async function deleteAttendance(local_id) {
  const db = await getDb();
  await db.delete(STORE, local_id);
}

export async function clearSynced() {
  const db = await getDb();
  const tx = db.transaction(STORE, "readwrite");
  const idx = tx.store.index("sync_status");
  for await (const cursor of idx.iterate("SYNCED")) {
    await cursor.delete();
  }
  await tx.done;
}

export async function setMeta(key, value) {
  const db = await getDb();
  await db.put(META, { key, value });
}

export async function getMeta(key) {
  const db = await getDb();
  const row = await db.get(META, key);
  return row ? row.value : null;
}
